import { render, staticRenderFns } from "./apkontrak-frm.vue?vue&type=template&id=ff707ad8"
import script from "./apkontrak-frm.vue?vue&type=script&lang=js"
export * from "./apkontrak-frm.vue?vue&type=script&lang=js"
import style0 from "./apkontrak-frm.vue?vue&type=style&index=0&id=ff707ad8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports